import { put, takeLatest, all } from "redux-saga/effects";
import {
  GET_SERVEY_LIST,
  GET_SERVEY_LIST_SUCCESS,
  GET_SERVEY_LIST_FAIL,
  ADD_SERVEY,
  ADD_SERVEY_SUCCESS,
  ADD_SERVEY_FAIL,
  GET_LUNG_TOTAL,
  GET_LUNG_TOTAL_SUCCESS,
  GET_LUNG_TOTAL_FAIL,
  GET_PROSTATE_TOTAL,
  GET_PROSTATE_TOTAL_SUCCESS,
  GET_PROSTATE_TOTAL_FAIL,
  GET_BREAST_TOTAL,
  GET_BREAST_TOTAL_SUCCESS,
  GET_BREAST_TOTAL_FAIL,
  GET_THYROID_TOTAL,
  GET_THYROID_TOTAL_SUCCESS,
  GET_THYROID_TOTAL_FAIL,
  // ADD_TOTAL,
  // ADD_TOTAL_SUCCESS,
  // ADD_TOTAL_FAIL,
} from "../actions/_actionType";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore/lite";

import { startLoading, finishLoading } from "../actions/_actions";

//상담 질문글 조회 하기
function* getQuestionList() {
  yield put(startLoading("GET_SERVEY_LIST"));
  try {
    const surveyData = yield collection(db, "survey_new");
    const surveySnapshot = yield getDocs(surveyData);
    const surveyList = yield surveySnapshot.docs.map((doc) => doc.data());
    yield put({
      type: GET_SERVEY_LIST_SUCCESS,
      list: surveyList,
    });
  } catch (error) {
    yield put({ type: GET_SERVEY_LIST_FAIL, payload: error, error: true });
  }
  yield put(finishLoading("GET_SERVEY_LIST"));
}

//설문 입력
function* addServey(action) {
  yield put(startLoading("ADD_SERVEY"));
  try {
    // Add a new document with a generated id.
    const surveyData = yield query(
      collection(db, "survey_new"),
      where("ip", "==", action.payload.ip)
    );
    const surveySnapshot = yield getDocs(surveyData);
    let abuCheck = true;
    let abuArr = [];

    if (surveySnapshot.empty) {
      abuCheck = false;
    } else {
      surveySnapshot.forEach((doc) => {
        abuArr.push(doc.data().cancerName);
      });
      let arrChecker = (element) => element === action.payload.cancerName;
      abuCheck = abuArr.findIndex(arrChecker) === -1 ? false : true;
    }
    if (abuCheck) {
      yield put({
        type: ADD_SERVEY_FAIL,
        error: true,
        message: "설문 조사는 1회 참여 가능합니다. 이미 작성하셨습니다.",
      });
    } else {
      yield addDoc(collection(db, "survey_new"), { ...action.payload, createTime: Timestamp.fromDate(new Date()) });
      yield put({
        type: ADD_SERVEY_SUCCESS,
        success: true,
      });
    }
  } catch (error) {
    yield put({
      type: ADD_SERVEY_FAIL,
      error: true,
      message: "다시 영상을 듣고 설문 작성을 부탁드립니다.",
    });
  }
  yield put(finishLoading("ADD_SERVEY"));
}

// 폐암 설문 작성 완료
function* getLungTotal(action) {
  yield put(startLoading("GET_LUNG_TOTAL"));
  console.log(action);
  const newData = {
    ...action.lungRe,
    total: action.total,
    cancer: "폐암",
    case9year: action.perCal.case9year,
    caseAge: action.perCal.caseAge.toString(),
    casedefaultAge: action.perCal.casedefaultAge,
    ip: action.perCal.ip,
    createTime: Timestamp.fromDate(new Date()),
  };
  try {
    yield addDoc(collection(db, "total"), newData);
    yield put({
      type: GET_LUNG_TOTAL_SUCCESS,
      total: action.total,
    });
  } catch (error) {
    yield put({
      type: GET_LUNG_TOTAL_FAIL,
      total: action.total,
    });
  }
  yield put(finishLoading("GET_LUNG_TOTAL"));
}

// 전립선암 설문 작성 완료
function* getProstateTotal(action) {
  yield put(startLoading("GET_PROSTATE_TOTAL"));
  console.log(action);
  const newData = {
    ...action.prostateRe,
    total: action.total,
    cancer: "전립선암",
    case9year: action.perCal.case9year,
    caseAge: action.perCal.caseAge.toString(),
    casedefaultAge: action.perCal.casedefaultAge,
    ip: action.perCal.ip,
    createTime: Timestamp.fromDate(new Date()),
  };
  try {
    yield addDoc(collection(db, "total"), newData);
    yield put({
      type: GET_PROSTATE_TOTAL_SUCCESS,
      total: action.total,
    });
  } catch (error) {
    yield put({
      type: GET_PROSTATE_TOTAL_FAIL,
      total: action.total,
    });
  }
  yield put(finishLoading("GET_PROSTATE_TOTAL"));
}

// 유방암 설문 작성 완료
function* getBreastTotal(action) {
  yield put(startLoading("GET_BREAST_TOTAL"));
  console.log(action);
  const newData = {
    ...action.breastRe,
    total: action.total,
    cancer: "유방암",
    case5year: action.perCal.case5year,
    caseAge: action.perCal.caseAge.toString(),
    ip: action.perCal.ip,
    createTime: Timestamp.fromDate(new Date()),
  };
  try {
    yield addDoc(collection(db, "total"), newData);
    yield put({
      type: GET_BREAST_TOTAL_SUCCESS,
      total: action.total,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: GET_BREAST_TOTAL_FAIL,
      total: action.total,
    });
  }
  yield put(finishLoading("GET_BREAST_TOTAL"));
}

// 갑상선암 설문 작성 완료
function* getThyroidTotal(action) {
  yield put(startLoading("GET_THYROID_TOTAL"));
  console.log(action);
  const newData = {
    ...action.thyroidRe,
    total: action.total,
    cancer: "갑상선암",
    case9year: action.perCal.case9year,
    caseAge: action.perCal.caseAge.toString(),
    casedefaultAge: action.perCal.casedefaultAge,
    ip: action.perCal.ip,
    createTime: Timestamp.fromDate(new Date()),
  };
  try {
    yield addDoc(collection(db, "total"), newData);
    yield put({
      type: GET_THYROID_TOTAL_SUCCESS,
      total: action.total,
    });
  } catch (error) {
    yield put({
      type: GET_THYROID_TOTAL_FAIL,
      total: action.total,
    });
  }
  yield put(finishLoading("GET_THYROID_TOTAL"));
}

function* actionWatcher() {
  yield takeLatest(GET_SERVEY_LIST, getQuestionList);
  yield takeLatest(ADD_SERVEY, addServey);
  yield takeLatest(GET_LUNG_TOTAL, getLungTotal);
  yield takeLatest(GET_PROSTATE_TOTAL, getProstateTotal);
  yield takeLatest(GET_BREAST_TOTAL, getBreastTotal);
  yield takeLatest(GET_THYROID_TOTAL, getThyroidTotal);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
